import { useState, useCallback, useEffect } from 'react';
import api from '../../../api';
import { useDebouncedCallback } from '../../../hooks/useDebounce';

/**
 * Hook for managing port data fetching and WebSocket updates
 */
export function usePorts() {
  const [ports, setPorts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showArchived, setShowArchived] = useState(false);

  const fetchPorts = useCallback(async (archived = false) => {
    setLoading(true);
    try {
      const url = archived ? '/ports/?archived=true' : '/ports/';
      const response = await api.get(url);
      if (response.data) {
        setPorts(response.data);
      }
    } catch (err) {
      console.error('Error fetching ports:', err);
      if (err.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else {
        setError('Failed to load ports');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPorts(showArchived);
  }, [fetchPorts, showArchived]);

  const debouncedFetch = useDebouncedCallback(() => {
    console.log('Debounced port fetch triggered');
    fetchPorts(showArchived);
  }, 2000);

  return {
    ports,
    setPorts,
    loading,
    error,
    setError,
    fetchPorts,
    debouncedFetch,
    showArchived,
    setShowArchived,
  };
}
